import { useQuery } from '@tanstack/react-query';
import { apiRequest } from '@/lib/queryClient';

export interface MenuCounts {
  photos: number;
  entities: number;
  itineraries: number;
  essays: number;
  neighborhoods: number;
}

export function useMenuCounts() {
  return useQuery<MenuCounts>({
    queryKey: ['/api/stats/menu-counts'],
    queryFn: async () => {
      const res = await apiRequest('GET', '/api/stats/menu-counts');
      return res.json();
    },
    staleTime: 300000,
  });
}
